export default __webpack_public_path__ + "static/media/dani_l.e2f56a15.jpg";